import React, { useState, useEffect, useRef, forwardRef } from 'react';
import logComponent from '../../common/logComponent';
import './Modal.css';

const Modal = forwardRef(function Modal(props, ref) {
  const { shouldExit, remainOnBackdropClick, hide, isVisible, children } = props;
  const [exiting, setExiting] = useState(false);

  if (logComponent('Modal')) { console.debug('Modal rendered'); }

  useEffect(() => {
    if (logComponent('Modal')) { console.debug('Modal onMount'); }
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'visible';
    };
  }, [])

  useEffect(() => {
    if (logComponent('Modal')) { console.debug('Modal useEffect [shouldExit]'); }
    setExiting(shouldExit);
  }, [shouldExit])


  const handleBackdropClick = (e) => {
    if (logComponent('Modal')) { console.debug('Modal handleBackdropClick'); }
    if (!remainOnBackdropClick)
      setExiting(true);
  }

  const handleContentClick = (e) => {
    if (logComponent('Modal')) { console.debug('Modal handleContentClick'); }
    e.stopPropagation();
  }

  const handleExitAnimationEnd = (e) => {
    if (logComponent('Modal')) { console.debug('Modal handleExitAnimationEnd'); }
    if (exiting && hide) hide();
  }

  return (
    <div
      ref={ref}
      className={'Modal' + (isVisible ? ' Modal--visible' : '') + (exiting ? ' Modal--exiting' : '')}>
      <div
        className="Modal__backdrop"
        onAnimationEnd={handleExitAnimationEnd}>
        <div
          className="Modal__content-plane"
          onClick={handleBackdropClick}>
          <div
            className="Modal__content"
            onClick={handleContentClick}>
            {children}
          </div>
        </div>
      </div>
    </div>
  );
});
export default Modal;